import React from 'react'
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialLinksFooter = () => {
    const links = [
        {
            id: 1,
            child: (
                <>
                    LinkedIn <FaLinkedin size={30} />
                </>
            ),
            href: 'https://linkedin.com/in/sebastiangimenezlopez',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                    Github <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/SebaGimenezOk',

        },
        {
            id: 3,
            child: (
                <>
                    Email<HiOutlineMail size={30} />
                </>
            ),
            href: 'mailto:sebastiangimenezlopezen@gmail.com',

        },
        {
            id: 4,
            child: (
                <>
                    Mi CV <BsFillPersonLinesFill size={30} />
                </>
            ),
            href: '/CV-SEPT-2025.pdf',
            style: 'rounded-br-md',
            download: true,
        },
    ]


    return (
        <div className=' flex justify-center items-center bg-gradient-to-t from-gray-900 to-slate-900
        
        pb-10'  >
            <ul>
                {links.map(({ id, child, href, style, download }) => (
                    <li key={id} className={'flex justify-between items-center w-40 h-14  px-4 ml-[-100px] hover:ml-[-10px]  hover:rounded-md duration-300 bg-slate-700' + style}>
                        <a href={href} className='flex justify-between items-center w-full text-white' download={download} target='_blank' rel='noreferrer' >
                            {child}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default SocialLinksFooter